import { render, staticRenderFns } from "./ChildProtectionPolicyKYY.vue?vue&type=template&id=1f0cbd14&scoped=true"
import script from "./ChildProtectionPolicyKYY.vue?vue&type=script&lang=js"
export * from "./ChildProtectionPolicyKYY.vue?vue&type=script&lang=js"
import style0 from "./ChildProtectionPolicyKYY.vue?vue&type=style&index=0&id=1f0cbd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0cbd14",
  null
  
)

export default component.exports